import { ToolRecord, toolFromJSON } from "common/records/Tool";
import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import { IdType } from "common/types";
import {
  ADD_TOOL_IMAGE,
  RECEIVE_TOOL,
  RECEIVE_TOOLS,
  REMOVE_TOOL,
  REMOVE_TOOL_IMAGE,
  RESET_TOOL,
  ToolActions,
} from "common/reducers/tool.actions";

export const ToolStateRecord = Record({
  byId: Map<IdType, ToolRecord>(),
  lastSavedById: Map<IdType, ToolRecord>(),
});

export const initialState = ToolStateRecord();
export type ToolState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  switch (action.type) {
    case RECEIVE_TOOL:
      const tool = toolFromJSON({ ...action.payload });

      return receive(state, "tools", tool) as RootState;

    case RECEIVE_TOOLS:
      action.payload.tools.forEach((tool) => {
        state = reducer(state, ToolActions.receiveTool(tool));
      });
      return state;

    case REMOVE_TOOL:
      return state.removeIn(["tools", "byId", action.payload]);

    case ADD_TOOL_IMAGE:
      const { imageFile, toolId } = action.payload;
      return state
        .setIn(["tools", "byId", toolId, "brand_image", "file_queue"], imageFile)
        .setIn(["tools", "byId", action.payload.toolId, "brand_image", "_destroy"], false);

    case REMOVE_TOOL_IMAGE:
      return state
        .setIn(["tools", "byId", action.payload.toolId, "brand_image", "file"], null)
        .setIn(["tools", "byId", action.payload.toolId, "brand_image", "file_queue"], null)
        .setIn(["tools", "byId", action.payload.toolId, "brand_image", "_destroy"], true);

    case RESET_TOOL:
      return reset(state, "tools", action.payload) as RootState;

    default:
      return state;
  }
};
